import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import I3CoachingLayout from './walkthrough/i3coaching/I3CoachingLayout';
import I3Shell from './walkthrough/i3coaching/I3Shell';
import I3Home from './walkthrough/i3coaching/pages/I3Home';
import I3About from './walkthrough/i3coaching/pages/I3About';
import I3Services from './walkthrough/i3coaching/pages/I3Services';
import I3Events from './walkthrough/i3coaching/pages/I3Events';
import I3Contact from './walkthrough/i3coaching/pages/I3Contact';
import I3Blog from './walkthrough/i3coaching/pages/I3Blog';
import I3BlogPost from './walkthrough/i3coaching/pages/I3BlogPost';
import I3AfterBooking from './walkthrough/i3coaching/pages/I3AfterBooking';

const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<I3CoachingLayout />}>
        <Route element={<I3Shell />}>
          <Route index element={<I3Home />} />
          <Route path="solution-overview" element={<Navigate to="/" replace />} />
          <Route path="whats-new" element={<Navigate to="/" replace />} />
          <Route path="about" element={<I3About />} />
          <Route path="services" element={<I3Services />} />
          <Route path="events" element={<I3Events />} />
          <Route path="blog" element={<I3Blog />} />
          <Route path="blog/:slug" element={<I3BlogPost />} />
          <Route path="contact" element={<I3Contact />} />
          <Route path="after-booking" element={<I3AfterBooking />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;
